import {
  ROBLOX_TOP_CHARTS_CHART_GROUP_BY,
  ROBLOX_TOP_CHARTS_CHART_PAGE_SIZE,
} from '../constants';
import { getRobloxTopChartsChartMetricFromSortKey } from '../config/robloxTopChartsSort';
import { buildRobloxTopChartsFetchParams } from './buildRobloxTopChartsFetchParams';

import type { IMainGenre } from '@intelligence/types/common';
import type { IRobloxTopChartsFilterValues } from '../types';

interface IBuildRobloxTopChartsChartFetchParamsOptions {
  gameIds: string[];
  sortKey?: string;
  sortOrder?: 'asc' | 'desc';
  /** 折线图展示指标；未传时从 sortKey 解析 */
  chartMetric?: string;
  robloxGenreOptions?: IMainGenre[];
}

export const buildRobloxTopChartsChartFetchParams = (
  filterValues: IRobloxTopChartsFilterValues,
  options: IBuildRobloxTopChartsChartFetchParamsOptions,
) => {
  const chartMetric = options.chartMetric
    || getRobloxTopChartsChartMetricFromSortKey(options.sortKey);

  const params = buildRobloxTopChartsFetchParams(filterValues, {
    gameIds: options.gameIds,
    page: 1,
    pageSize: ROBLOX_TOP_CHARTS_CHART_PAGE_SIZE,
    sortKey: options.sortKey,
    sortOrder: options.sortOrder,
    metrics: chartMetric ? [chartMetric] : undefined,
    robloxGenreOptions: options.robloxGenreOptions,
  });

  params.group_by = [...ROBLOX_TOP_CHARTS_CHART_GROUP_BY];

  return params;
};
